module.exports = __webpack_public_path__ + "img/vip-hint.134c3031.png";